var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('video', {
    ref: "cameraVideo",
    attrs: {
      "playsinline": ""
    }
  }), _c('canvas', {
    ref: "cameraCanvas",
    attrs: {
      "id": "cameraCanvas",
      "aria-hidden": "true"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }